import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
interface CountdownTimerProps {
  tone?: 'dark' | 'light';
}
export function CountdownTimer({
  tone = 'light'
}: CountdownTimerProps) {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const isDark = tone === 'dark';
  return <div className={`mx-auto flex w-full max-w-sm flex-col items-center gap-2 rounded-xl border px-4 py-3 ${isDark ? 'border-white/15 bg-white/5' : 'border-red-200 bg-red-50'}`} role="timer" aria-live="off" data-id="element-19" data-mp="34ra2a6dycers">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-brand-100' : 'text-red-700'}`} data-id="element-20" data-mp="1c31dzd26yucr">
        <ClockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-21" data-mp="124bujfund1ue" />
        This price expires in
      </p>
      <div className="flex items-end gap-1.5" data-id="element-22" data-mp="173ogzzhlw6wg">
        {[{
        value: hours,
        label: 'hrs'
      }, {
        value: minutes,
        label: 'min'
      }, {
        value: seconds,
        label: 'sec'
      }].map((unit, i) => <React.Fragment key={unit.label} data-id="element-23" data-mp="1l1d3fbrbnm3m" data-mpi={i}>
            {i > 0 && <span className={`pb-4 text-xl font-bold ${isDark ? 'text-white/40' : 'text-red-300'}`} data-id="element-24" data-mp="1l13cnlygdawv">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-25" data-mp="2do7jlwh3vzba">
              <span className={`min-w-[52px] rounded-lg px-2 py-1.5 text-center font-display text-2xl font-black tabular-nums ${isDark ? 'bg-white text-navy-900' : 'bg-navy-900 text-white'}`} data-id="element-26" data-mp="2ihity7l4my7y">
                {pad(unit.value)}
              </span>
              <span className={`mt-1 text-[10px] font-semibold uppercase tracking-wider ${isDark ? 'text-brand-100' : 'text-red-700'}`} data-id="element-27" data-mp="2ja84b1e5483q">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}